export interface PersistenceLogMeta {
  action: string;
  correlationId: string;
  entityType?: string;
  entityId?: string;
  route?: string;
  userId?: string;
  [key: string]: unknown;
}

function makeCorrelationId(prefix: string): string {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export function startPersistenceLog(
  action: string,
  meta: Omit<PersistenceLogMeta, "action" | "correlationId"> = {},
): string {
  const correlationId = makeCorrelationId(action);
  const payload: PersistenceLogMeta = { action, correlationId, ...meta };
  console.info("[Persistence][start]", payload);
  return correlationId;
}

export function successPersistenceLog(
  action: string,
  correlationId: string,
  meta: Omit<PersistenceLogMeta, "action" | "correlationId"> = {},
): void {
  const payload: PersistenceLogMeta = { action, correlationId, ...meta };
  console.info("[Persistence][success]", payload);
}

export function errorPersistenceLog(
  action: string,
  correlationId: string,
  error: unknown,
  meta: Omit<PersistenceLogMeta, "action" | "correlationId"> = {},
): void {
  const payload: PersistenceLogMeta = {
    action,
    correlationId,
    error: error instanceof Error ? error.message : String(error),
    ...meta,
  };
  console.error("[Persistence][error]", payload);
}

